
<div class="modal-header">
  <h4 class="modal-title pull-left">Personalizar capa</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form class="row g-0" [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
    <label *ngFor="let color of colors" class="col-6 col-sm-4 col-md-3 color-label">
      <input type="radio" name="color" [value]="color.id"  formControlName="color" class="color-radio"/>
      <span class="color-box" [ngStyle]="{'background-color':'#' + color.id}" [title]="color.label"></span>
    </label>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="onCloseModal()">Cancelar</button>
        <button class="btn btn-primary" type="submit">Salvar</button>
      </div>
    </div>
  </form>
</div>
<app-loading [loader]="isLoading"></app-loading>
